import React, { useEffect, useState } from "react";
import { TextInputComponents } from "./TextInputComponents";

interface LifeAtMultiLineTextInputProps {
    readonly textValue: string;
    readonly handleUpdate?: (editValue: string) => void;
    readonly onInputChange?: (editValue: string) => void;
    readonly onBlur?: (e: React.FocusEvent<HTMLTextAreaElement, Element>) => void;
    readonly onFocus?: (e: React.FocusEvent<HTMLTextAreaElement, Element>) => void;
    readonly placeholder?: string;
    readonly minHeightPx?: number;
    readonly maxHeightPx?: number;
    readonly label?: string;
    readonly showBorder?: boolean;
    readonly fontSizeCss?: string;
    readonly errorMessage?: string;
    readonly isDisabled?: boolean;
    readonly maxCharacterCount?: number;
    readonly handleKeyPress?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    readonly inputRef?: React.MutableRefObject<HTMLTextAreaElement | null>;
    readonly className?: string;
}
export default function LifeAtMultiLineTextInput(props: LifeAtMultiLineTextInputProps) {
    const [inputVal, setInputVal] = useState(props.textValue);
    const updateInputVal = (editValue: string) => {
        if (!props.maxCharacterCount || editValue.length <= props.maxCharacterCount) {
            setInputVal(editValue);
            props.onInputChange?.(editValue);
        }
    };

    // If the value changes from the parent, we should update the input value to display
    // the correct contents. E.g. user edits to-do list name in menubar window, we need to
    // have the to-do list names in the selector dropdown update in the main app window.
    useEffect(() => {
        if (props.textValue && props.textValue !== inputVal) {
            setInputVal(props.textValue);
        }
    }, [props.textValue]);

    return (
        <TextInputComponents.TextAreaWrapper
            label={props.label}
            showBorder={props.showBorder}
            errorMessage={props.errorMessage}
            isDisabled={props.isDisabled}
            className={props.className}
        >
            <TextInputComponents.TextArea
                ref={props.inputRef}
                value={inputVal}
                placeholder={props.placeholder}
                autoComplete={"off"}
                rows={1}
                onChange={(e) => updateInputVal(e.target.value)}
                onBlur={(e) => {
                    props.handleUpdate?.(e.target.value);
                    props.onBlur?.(e);
                }}
                onFocus={props.onFocus}
                disabled={props.isDisabled ?? false}
                $minHeight={props.minHeightPx}
                $maxHeight={props.maxHeightPx}
                onKeyDown={props.handleKeyPress}
                onClick={(e) => e.stopPropagation()}
                fontSizeCss={props.fontSizeCss}
            />
        </TextInputComponents.TextAreaWrapper>
    );
}
